import React from 'react'
import { getStaffDocs } from '../../Helpers/GeneralHelpers'
import StaffCard from './StaffCard'
import { Container, Grid } from '@material-ui/core'

class StaffContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            staff: null
        }
        this.getStaff()
    }

    getStaff = () => {
        getStaffDocs().then(staffDocs => {
            this.setState({ staff: staffDocs })
        })
    }

    render() {
        return (
            <Container>
                <Grid container spacing={6}>
                    {this.state.staff !== null && this.state.staff.map(s => (
                        <StaffCard key={s.id} staffMember={s} />
                    ))}
                </Grid>
            </Container>
        )
    }
}

export default StaffContainer